var _path, _path2, _path3, _rect, _path4, _circle, _path5, _circle2, _path6, _circle3, _path7, _path8, _rect2, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7H23L28 3H46L51 7H64L74 1H0L10 7Z",
    fill: "#7D7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M368.169 1H0",
    stroke: "white",
    strokeOpacity: 0.45,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M368.169 1H377.669L404.669 21",
    stroke: "white",
    strokeOpacity: 0.45,
    strokeWidth: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 403.665,
    y: 20,
    width: 2,
    height: 2,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M461.449 15V4.92H463.689L467.105 8.994L470.507 4.92H472.761V15H470.577V8.238L467.105 12.382L463.619 8.252V15H461.449Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.24,
    cx: 511.498,
    cy: 10,
    r: 1,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M550.144 15V4.92H559.454V7.104H552.342V8.868H558.068V11.052H552.342V12.816H559.454V15H550.144Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.24,
    cx: 598.165,
    cy: 10,
    r: 1,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M640.156 15L636.488 4.92H638.798L640.996 10.926L643.194 4.92H645.196L647.408 10.926L649.606 4.92H651.902L648.234 15H646.568L644.188 8.518L641.822 15H640.156Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.24,
    cx: 690.832,
    cy: 10,
    r: 1,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M731.451 15C731.078 15 730.737 14.9067 730.429 14.72C730.121 14.5333 729.874 14.286 729.687 13.978C729.5 13.67 729.407 13.334 729.407 12.97V12.186H731.549V12.858H737.163V10.996H731.059V8.854H736.785V7.062H731.549V7.846H729.407V6.95C729.407 6.57667 729.5 6.236 729.687 5.928C729.874 5.62 730.121 5.37733 730.429 5.2C730.737 5.01333 731.078 4.92 731.451 4.92H736.897C737.27 4.92 737.611 5.01333 737.919 5.2C738.227 5.37733 738.47 5.62 738.647 5.928C738.834 6.236 738.927 6.57667 738.927 6.95V8.966C738.927 9.06867 738.918 9.18067 738.899 9.302C738.89 9.414 738.871 9.51667 738.843 9.61C738.983 9.778 739.095 9.974 739.179 10.198C739.263 10.4127 739.305 10.6413 739.305 10.884V12.97C739.305 13.334 739.212 13.67 739.025 13.978C738.848 14.286 738.605 14.5333 738.297 14.72C737.989 14.9067 737.648 15 737.275 15H731.451Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M831.831 1H823.331L796.331 21",
    stroke: "white",
    strokeOpacity: 0.45,
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 795.665,
    y: 20,
    width: 2,
    height: 2,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1136 7H1149L1154 3H1172L1177 7H1190L1200 1H1126L1136 7Z",
    fill: "#7D7C7C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1200 1H831.831",
    stroke: "white",
    strokeOpacity: 0.45,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLine);
export default __webpack_public_path__ + "static/media/bottomLine.90fa863a977d58688511219862adc162.svg";
export { ForwardRef as ReactComponent };